import React, { useState } from "react";
import { Edit, X } from "react-feather";
import { Form, FormGroup, Input } from "reactstrap";
import { Href, SettingsMessage, SettingsTitle } from "../../../../../Constants/Constants";
import { useAppDispatch } from "../../../../../ReduxToolkit/Hooks";
import { closeLeftSide } from "../../../../../ReduxToolkit/Reducers/Messenger/MainSidebar";
import { dynamicImage, Image } from "../../../../../Utils";

const SettingsHeading = () => {
  const dispatch = useAppDispatch();
  const [profile, setProfile] = useState({
    username: "Josephin water",
    address: "Alabma , USA",
    editStatus: false,
  });
  const ProfileHandle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setProfile({ ...profile, [name]: value });
  };
  const EditProfile = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setProfile({ ...profile, editStatus: !profile.editStatus });
  };

  return (
    <div className="template-title">
      <div className="d-flex">
        <div>
          <h3>{SettingsTitle}</h3>
          <p>{SettingsMessage}</p>
        </div>
        <div className="flex-grow-1">
          <a className="icon-btn btn-outline-light btn-sm close-panel" href={Href} onClick={() => dispatch(closeLeftSide())}>
            <X />
          </a>
        </div>
      </div>
      <div className="profile-box">
        <div className={`d-flex ${profile.editStatus ? "open" : ""}`}>
          <div className="profile">
            <Image className="bg-img" src={dynamicImage("contact/2.jpg")} alt="Avatar" />
          </div>
          <div className="details pt-0">
            <h4>Josephin water </h4>
            <h6 className="font-light">Alabma , USA</h6>
          </div>
          <div className="details edit">
            <Form className="form-radious form-sm">
              <FormGroup>
                <Input type="text" name="username" defaultValue={profile.username} onChange={(e) => ProfileHandle(e)} />
              </FormGroup>
              <FormGroup className="m-0">
                <Input type="text" name="address" defaultValue={profile.address} onChange={(e) => ProfileHandle(e)} />
              </FormGroup>
            </Form>
          </div>
          <div className="flex-grow-1">
            <a className="icon-btn btn-outline-light btn-sm pull-right edit-btn" href={Href} onClick={(e) => EditProfile(e)}>
              <Edit />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsHeading;
